import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { RaadLogo } from '@/components/RaadLogo';

/** In-app 404 (canvas-styled). Public — reachable signed in or out. */
export function NotFound() {
  const { t } = useTranslation();
  return (
    <main className="flex min-h-dvh flex-col items-center justify-center bg-raad-bg px-6 text-center text-raad-text">
      <RaadLogo size={44} />
      <p className="mt-6 font-display text-5xl font-bold text-raad-accent">404</p>
      <h1 className="mt-3 font-display text-xl font-bold">{t('notFound.title')}</h1>
      <p className="mt-2 max-w-sm text-sm text-raad-muted">{t('notFound.body')}</p>
      <Link
        to="/"
        className="mt-7 flex min-h-12 items-center justify-center rounded-xl bg-raad-primary px-5 text-sm font-bold text-raad-onprimary transition-opacity hover:opacity-95"
      >
        {t('notFound.back')}
      </Link>
    </main>
  );
}
